(function (global) {
  'use strict';

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function bucketFor(nowMs, bucketMs) {
    return Math.floor(nowMs / bucketMs);
  }

  // Seed deterministico: stesso bucket -> stesso valore (coerenza tra reload
  // ravvicinati), bucket diverso -> valore diverso (evoluzione lenta nel tempo).
  function seededValue(bucket, min, max) {
    var x = Math.sin(bucket * 12.9898) * 43758.5453;
    var frac = x - Math.floor(x);
    var span = max - min + 1;
    return min + Math.floor(frac * span);
  }

  function nextValue(current, min, max, rng) {
    var r = (rng || Math.random)();
    var delta = r < 0.5 ? -1 : 1;
    return clamp(current + delta, min, max);
  }

  var api = { clamp: clamp, bucketFor: bucketFor, seededValue: seededValue, nextValue: nextValue };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (typeof HTMLElement !== 'undefined' && typeof customElements !== 'undefined' && !customElements.get('tk-live-viewers')) {
    var BUCKET_MS = 600000;
    var INTERVAL_MS = 12000;

    class TkLiveViewers extends HTMLElement {
      connectedCallback() {
        this.textEl = this.querySelector('[data-role="text"]');
        if (!this.textEl) return;
        this.min = Number(this.dataset.min) || 1;
        this.max = Number(this.dataset.max) || this.min;
        if (this.max < this.min) this.max = this.min;
        this.tpl = this.dataset.tpl || '';

        this.current = seededValue(bucketFor(Date.now(), BUCKET_MS), this.min, this.max);
        this.paint();
        this.timer = setInterval(this.tick.bind(this), INTERVAL_MS);
      }

      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
      }

      tick() {
        this.current = nextValue(this.current, this.min, this.max);
        this.paint();
      }

      paint() {
        this.textEl.innerHTML = this.tpl.replace('[count]', this.current);
      }
    }

    customElements.define('tk-live-viewers', TkLiveViewers);
  }
})(typeof window !== 'undefined' ? window : this);
